const InclusionDetailsLoadFull = (
    contentId: string,
    showLoadBtn: boolean = false,
    afterLoadCallBack?: () => void
) => {
    const contentContainer = document.getElementById(contentId);

    if (!contentContainer) {
        return;
    }

    const inclusionTiles = contentContainer.querySelectorAll<HTMLElement>(
        '.inclusion-detail-tile',
    );
    const loadMoreBtn = contentContainer.querySelector<HTMLButtonElement>(
        '.js-inclusions-load-more',
    );
    const viewAllBtn = contentContainer.querySelector<HTMLButtonElement>(
        '.js-inclusions-view-all',
    );

    let visibleCount: number = window.innerWidth >= 768 ? 6 : 3;
    let currentVisibleCount: number = 0;

    const showItems = (count: number): void => {
        for (
            let i = currentVisibleCount;
            i < currentVisibleCount + count && i < inclusionTiles.length;
            i++
        ) {
            inclusionTiles[i].classList.add('active'); // Add the 'active' class to show the item
        }
        currentVisibleCount += count;
    };

    const loadMoreItems = () => {
        const hiddenItems = Array.from(inclusionTiles).filter(
            item => !item.classList.contains('active'),
        );

        // Show the next batch of hidden items
        const itemsToShow = hiddenItems.slice(0, visibleCount);
        itemsToShow.forEach(item => {
            item.classList.add('active'); // Add the 'active' class
        });

        // Hide the "Load More" button if no more hidden items
        if (hiddenItems.length <= visibleCount) {
            if (loadMoreBtn) {
                loadMoreBtn.style.display = 'none';
            }
            if (viewAllBtn) {
                viewAllBtn.style.display = 'none';
            }
        }

        //primarily used for sticky nav to refresh calculations
        if (afterLoadCallBack) {
            afterLoadCallBack();
        }
    };

    const viewAllItems = (): void => {
        // Show all remaining items
        inclusionTiles.forEach(item => {
            item.classList.add('active'); // Add the 'active' class to show all items
        });

        // Hide buttons
        if (loadMoreBtn) {
            loadMoreBtn.style.display = 'none';
        }

        if (viewAllBtn) {
            viewAllBtn.style.display = 'none';
        }

        //primarily used for sticky nav to refresh calculations
        if (afterLoadCallBack) {
            afterLoadCallBack();
        }
    };

    const init = () => {
        if (loadMoreBtn) {
            loadMoreBtn.addEventListener('click', loadMoreItems);
        }

        if (viewAllBtn) {
            viewAllBtn.addEventListener('click', viewAllItems);
        }
    };

    const updateVisibleCount = () => {
        visibleCount = window.innerWidth >= 768 ? 6 : 3;

        // Reset current visible count
        currentVisibleCount = 0;

        // Remove the 'active' class from all items initially
        inclusionTiles.forEach(item => {
            item.classList.remove('active');
        });

        showItems(visibleCount); // Show the new number of items
    };

    // Debounced resize function
    let resizeTimeout: number;
    const onResize = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = window.setTimeout(updateVisibleCount, 100);
    };

    window.addEventListener('resize', onResize);

    // Show the initial number of items
    showItems(visibleCount);

    // Show the Load More button if needed
    if (showLoadBtn) {
        if (loadMoreBtn) {
            loadMoreBtn.style.display = 'inline-block';
        }

        if (viewAllBtn) {
            viewAllBtn.style.display = 'inline-block';
        }
    }

    init(); // Initialize the event listeners
};

export default InclusionDetailsLoadFull;
